;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import urlJoin from 'url-join';

import { LOCALES } from './i18nConfig';
import getStateSlug from './utils/api/getStateSlug';
import { getAreaSlug, getCitySlug, getDistrictSlug } from './utils/api/slugs';
import { addLocale } from './utils/locales';
import { LocationDetail } from './utils/types';

export const ROUTES = {
  home: '/',
  alert: (lang: string) => {
    const searchParams = new URLSearchParams({ lang });

    return `/api/alert/?${searchParams.toString()}`;
  },
  announcement: (lang: string) => {
    const searchParams = new URLSearchParams({ lang });

    return `/api/announcement/?${searchParams.toString()}`;
  },
  blogPost: (id: string): string => `/blog/${id}/`,
  verify: '/verify/',
  APILocations: '/api/locations/',
  APILocationsFees: '/api/locations/fees/',
  APIETransferRates: '/api/e-transfer/rates/',
  APIUserLocation: '/api/user-location/',
  APICryptos: '/api/cryptos/',
  APICryptoChanges: (coins: string): string => {
    const params = new URLSearchParams({ coins });

    return `/api/crypto-changes?${params.toString()}`;
  },
  APINearestATMS: (region?: string): string => `/api/nearest-atms/${region || ''}/`,
  APIHostATMForm: '/api/host-atm-form/',
  APIContactUsForm: '/api/contact-us-form/',
  APITransactionById: (transactionId: string): string =>
    `/api/transaction-by-id/?transactionId=${transactionId}/`,
  APITransactionsByWallet: '/api/transactions-by-wallet/',
  APISurveySubmit: '/api/survey/submit/',
  APISurveySubmitDirectFeedback: '/api/survey/submit/direct-feedback/',
  eTransferExchangeRate: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    '/api/sell-crypto/e-transfer/exchange-rate',
  ),
  state: (stateSlug: string): string => `/bitcoin-atm/${stateSlug}/`,
  area: (areaSlug: string): string => `/bitcoin-atm/hong-kong/${areaSlug}/`,
  city: (stateSlug: string, citySlug: string): string => `/bitcoin-atm/${stateSlug}/${citySlug}/`,
  district: (areaSlug: string, districtSlug: string): string =>
    `/bitcoin-atm/hong-kong/${areaSlug}/${districtSlug}/`,
  fullAddress: (location: LocationDetail): string => {
    if (location.country === 'Hong Kong') {
      return `${location.street}, ${location.district}, ${location.country}`;
    }

    return `${location.street}, ${location.city}, ${location.zip}, ${location.country}`;
  },
  location: (location: LocationDetail): string => {
    if (location.country === 'Hong Kong') {
      return `/bitcoin-atm/hong-kong/${getAreaSlug(location.area)}/${getDistrictSlug(location.district)}/${location.publicId}/`;
    }

    return `/bitcoin-atm/${getStateSlug(location)}/${getCitySlug(location.city)}/${location.publicId}/`;
  },
  bitcoinATM: (lang: string) =>
    lang === LOCALES.EN_HK || lang === LOCALES.ZH_HK ? '/bitcoin-atm/hong-kong/' : '/bitcoin-atm/',
  bitcoinATMLocalized: (lang: string) => {
    const path =
      lang === LOCALES.EN_HK || lang === LOCALES.ZH_HK
        ? '/bitcoin-atm/hong-kong/'
        : '/bitcoin-atm/';

    return addLocale(path, lang);
  },
  map: '/map/',
  InteracLink: '/e-transfer-sell/',
  guidePost: (id: string): string => `/guide/${id}/`,
  sellCryptoSendVerificationSms: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/send-verification-sms',
  ),
  sellCryptoVerifyPin: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/verify-pin',
  ),
  sellCryptoDiscountCode: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/apply-discount-code',
  ),
  sellCryptoOrderDetails: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/v2/order',
  ),
  sellCryptoBillDistribution: (locationId: string): string =>
    urlJoin(
      `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
      `api/sell-crypto/${locationId}/bill-distribution`,
    ),
  sellCryptoSell: urlJoin(`${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`, 'api/sell-crypto/sell'),
  sellCryptoLimits: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/limits',
  ),
  contact: '/contact/',
  onlineSellETransferRoot: '/online-sell/e-transfer/',
  survey: '/survey/',
  surveyCompleted: '/survey/completed/',
  surveyDirectFeedback: '/survey/completed/direct-feedback/',
  preSell: '/pre-sell/',
  preSellOrder: '/pre-sell/order/',
  eTransfer: '/e-transfer/',
  eTransferOrder: '/e-transfer/order/',
  eBuy: '/e-buy/',
  eBuyOrder: '/e-buy/order/',
  eBuySendVerificationSms: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/send-verification-sms',
  ),
  eBuyVerifyPin: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/buy-verify-pin',
  ),
  eBuyCreateOrder: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/buy',
  ),
  eBuyRates: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/sell-crypto/e-transfer/buy-rates',
  ),
  kyc: '/kyc/',
  kycSubmitTosAndPp: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/kyc/submit-tos-pp',
  ),
  kycVerifyPin: urlJoin(`${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`, 'api/kyc/verify-code'),
  kycSendVerificationSms: urlJoin(
    `${process.env.NEXT_PUBLIC_SELL_CRYPTO_API_URL}`,
    'api/kyc/send-verification-sms',
  ),
  kycClearWebhook: '/api/kyc/clear-webhook',
  account: '/account',
  accountProfile: '/account/profile',
  accountTransactions: '/account/transactions',
  accountLimits: '/account/limits',
  accountAtmFinder: '/account/atm-finder',
  accountMore: '/account/more',
  accountAuth: '/auth',
  accountAuthRequestOtp: '/api/account/auth/request-otp',
  accountAuthVerifyOtp: '/api/account/auth/verify-otp',
  accountAuthLogout: '/api/account/auth/logout',
  accountAPIProfile: '/api/account/profile',
  accountAPITransactions: '/api/account/transactions',
  termsOfService: '/terms-service/',
  accountAPILimits: '/api/account/limits',
};
